const CLAIM_PATH = "/claim";

function escapeHtml(value) {
  return String(value ?? "").replace(/[&<>"']/g, (char) => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
  })[char]);
}

function isClaimRoute() {
  return window.location.pathname === CLAIM_PATH;
}

function tokenFromUrl() {
  return new URLSearchParams(window.location.search).get("token") || "";
}

function claimRoot() {
  let page = document.getElementById("page-claim");
  if (page) return page;
  page = document.createElement("div");
  page.className = "page";
  page.id = "page-claim";
  document.body.appendChild(page);
  return page;
}

function setClaimPageActive() {
  document.querySelectorAll(".page,.biz-page").forEach((node) => node.classList.remove("active"));
  claimRoot().classList.add("active");
}

function claimStyle() {
  if (document.getElementById("claimPageStyle")) return;
  const style = document.createElement("style");
  style.id = "claimPageStyle";
  style.textContent = `
    body.claim-route .nav-right{display:none}
    body.claim-route .logo{cursor:pointer}
    #page-claim{min-height:calc(100vh - 70px);display:none;place-items:center;padding:22px;background:radial-gradient(circle at top,rgba(255,106,0,.08),transparent 28rem),#f6f7f9}
    #page-claim.active{display:grid}
    .claim-card{width:min(560px,100%);border:1px solid #e5e7eb;border-radius:22px;background:#fff;padding:26px;box-shadow:0 14px 34px rgba(15,23,42,.08)}
    .claim-kicker{display:inline-flex;border-radius:999px;background:#fff3e8;color:#ff6a00;padding:5px 11px;font-size:12px;font-weight:800;text-transform:uppercase;letter-spacing:.08em;margin-bottom:10px}
    .claim-title{font-size:clamp(28px,5vw,42px);line-height:1.08;margin:0 0 8px;color:#1e293b;font-weight:900}
    .claim-sub{color:#6b7280;margin:0 0 18px;line-height:1.55}
    .claim-business{border:1px solid #e5e7eb;border-radius:18px;padding:14px;margin:14px 0;background:#f9fafb;color:#1e293b;font-weight:800}
    .claim-form{display:grid;gap:12px}.claim-form label{display:grid;gap:6px;color:#1e293b;font-size:13px;font-weight:700}.claim-form input{min-height:46px;border-radius:14px;border:1px solid #e5e7eb;background:#fff;color:#15171a;padding:10px 12px}
    .claim-actions{display:flex;gap:10px;flex-wrap:wrap;margin-top:14px}.claim-btn{min-height:46px;border:1px solid #e5e7eb;border-radius:14px;padding:10px 14px;font-weight:900;cursor:pointer}.claim-primary{background:#ff6a00;border-color:#ff6a00;color:#fff}.claim-secondary{background:#fff;color:#1e293b;border-color:#e5e7eb}
    .claim-error{border:1px solid rgba(220,38,38,.28);background:rgba(220,38,38,.08);color:#991b1b;border-radius:14px;padding:12px;margin-top:12px}
    .claim-success-icon{width:58px;height:58px;border-radius:50%;display:grid;place-items:center;background:#16a34a;color:#fff;font-size:32px;margin-bottom:14px;animation:claim-pop .36s ease-out}
    @keyframes claim-pop{from{transform:scale(.72);opacity:.3}to{transform:scale(1);opacity:1}}
  `;
  document.head.appendChild(style);
}

function render(html) {
  claimStyle();
  document.body.classList.add("claim-route");
  const logo = document.querySelector(".nav .logo");
  if (logo && logo.dataset.claimBound !== "1") {
    logo.dataset.claimBound = "1";
    logo.removeAttribute("data-action-click");
    logo.setAttribute("role", "link");
    logo.setAttribute("tabindex", "0");
    const openHome = () => window.location.assign("/");
    logo.addEventListener("click", openHome);
    logo.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        openHome();
      }
    });
  }
  setClaimPageActive();
  claimRoot().innerHTML = html;
  document.documentElement.classList.remove("torqo-booting");
}

async function requestJson(url, options = {}) {
  const response = await fetch(url, {
    ...options,
    headers: {
      "content-type": "application/json",
      ...(options.headers || {}),
    },
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(body.message || body.error || `HTTP ${response.status}`);
  }
  return body;
}

async function currentUser() {
  try {
    const res = await fetch("/api/auth/me", { headers: { accept: "application/json" } });
    if (!res.ok) return null;
    const body = await res.json();
    return body.user || null;
  } catch {
    return null;
  }
}

function renderLoading() {
  render(`
    <main class="claim-card">
      <div class="claim-kicker">Torqo invite</div>
      <h1 class="claim-title">Перевіряємо запрошення...</h1>
      <p class="claim-sub">Зачекайте кілька секунд. Ми перевіряємо, чи токен ще дійсний.</p>
    </main>
  `);
}

function renderInvalid(message) {
  render(`
    <main class="claim-card">
      <div class="claim-kicker">Запрошення недійсне</div>
      <h1 class="claim-title">Не вдалося підключити бізнес</h1>
      <p class="claim-sub">${escapeHtml(message || "Посилання вже використано або термін дії завершився.")}</p>
      <div class="claim-actions"><a class="claim-btn claim-secondary" href="/">На карту Torqo</a></div>
    </main>
  `);
}

function renderSuccess() {
  render(`
    <main class="claim-card">
      <div class="claim-success-icon">✓</div>
      <h1 class="claim-title">Бізнес підключено</h1>
      <p class="claim-sub">Зараз перенаправимо вас у бізнес-кабінет.</p>
    </main>
  `);
  window.setTimeout(() => {
    window.location.href = "/dashboard/business";
  }, 2000);
}

async function acceptClaim(token) {
  await requestJson("/api/claim/accept", {
    method: "POST",
    body: JSON.stringify({ token }),
  });
  renderSuccess();
}

function renderValid({ token, businessName, user }) {
  const form = user ? "" : `
    <form class="claim-form" id="claimAuthForm">
      <label>Ім'я<input name="name" autocomplete="name" required></label>
      <label>Телефон<input name="phone" autocomplete="tel" required></label>
      <label>Email<input name="email" type="email" autocomplete="email" required></label>
      <label>Пароль<input name="password" type="password" autocomplete="new-password" minlength="6" required></label>
      <button class="claim-btn claim-primary" type="submit">Зареєструватися і підключити</button>
    </form>
  `;

  render(`
    <main class="claim-card">
      <div class="claim-kicker">Запрошення власника</div>
      <h1 class="claim-title">Підключіть бізнес до Torqo</h1>
      <p class="claim-sub">Після підтвердження цей бізнес з'явиться у вашому бізнес-кабінеті.</p>
      <div class="claim-business">${escapeHtml(businessName || "Бізнес Torqo")}</div>
      ${user ? `<button class="claim-btn claim-primary" id="claimAcceptBtn" type="button">Підключити бізнес</button>` : form}
      <div class="claim-error" id="claimError" hidden></div>
    </main>
  `);

  document.getElementById("claimAcceptBtn")?.addEventListener("click", async () => {
    try {
      await acceptClaim(token);
    } catch (err) {
      showClaimError(err.message);
    }
  });

  document.getElementById("claimAuthForm")?.addEventListener("submit", async (event) => {
    event.preventDefault();
    const data = Object.fromEntries(new FormData(event.currentTarget).entries());
    try {
      // Реальная регистрация/логин должна поставить server session cookie; role/userId с фронта не передаются.
      await requestJson("/api/auth/register", { method: "POST", body: JSON.stringify(data) }).catch(async () => {
        await requestJson("/api/auth/login", { method: "POST", body: JSON.stringify({ email: data.email, password: data.password }) });
      });
      await acceptClaim(token);
    } catch (err) {
      showClaimError(err.message || "Увійдіть в акаунт і повторіть підключення.");
    }
  });
}

function showClaimError(message) {
  const node = document.getElementById("claimError");
  if (!node) return;
  node.hidden = false;
  node.textContent = message;
}

export async function initClaimPage() {
  if (!isClaimRoute()) return;
  const token = tokenFromUrl();
  renderLoading();
  if (!token) {
    renderInvalid("У посиланні немає токена запрошення.");
    return;
  }

  try {
    const validation = await requestJson(`/api/claim/validate?token=${encodeURIComponent(token)}`);
    if (!validation.valid) {
      renderInvalid(validation.message);
      return;
    }
    renderValid({ token, businessName: validation.businessName, user: await currentUser() });
  } catch (err) {
    renderInvalid(err.message || "Не вдалося перевірити запрошення.");
  }
}
